import { fortunesDe_at } from './fortunes_de_at'
import { fortunesEn } from './fortunes_en'
import { fortunesEn_ae } from './fortunes_en_ae'
import { fortunesEn_at } from './fortunes_en_at'
import { fortunesEn_it } from './fortunes_en_it'
import { fortunesEn_ph } from './fortunes_en_ph'
import { fortunesEn_tn } from './fortunes_en_tn'
import { fortunesEs } from './fortunes_es'
import { fortunesFr_ca } from './fortunes_fr_ca'
import { fortunesHi } from './fortunes_hi'
import { fortunesIt } from './fortunes_it'
import { fortunesPt } from './fortunes_pt'

const ALL_FORTUNES = {
  en: fortunesEn,
  es: fortunesEs,
  pt: fortunesPt,
  hi: fortunesHi,
  it: fortunesIt,
  'es-mx': fortunesEs,
  'en-in': fortunesEn,
  'fr-ca': fortunesFr_ca,
  'en-ph': fortunesEn_ph,
  'en-tn': fortunesEn_tn,
  'en-it': fortunesEn_it,
  'en-at': fortunesEn_at,
  'de-at': fortunesDe_at,
  'en-ae': fortunesEn_ae
}

export default ALL_FORTUNES
